/* ══════════════════════════════════════════════════════════════
   BRUTECH VARIANT PICKER
   Resolves selected options to a variant, updates the form, and
   emits BOTH 'variant:change' and 'variant:changed' so the stock
   theme listeners and the existing Brutech listener both fire.
   Load AFTER brutech-lorgar-product.js
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_format); }
      catch (e) { /* fall through */ }
    }
    var v = (cents / 100).toFixed(2);
    return 'R' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function init(root) {
    if (root.dataset.blReady) return;
    root.dataset.blReady = '1';

    var dataEl = root.querySelector('[data-bl-variant-data]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); }
    catch (e) { console.warn('[Brutech] Variant JSON:', e); return; }
    if (!variants || !variants.length) return;

    var formId    = root.getAttribute('data-form-id');
    var form      = formId ? document.getElementById(formId) : null;
    var updateUrl = root.getAttribute('data-update-url') === 'true';
    var hideSold  = root.getAttribute('data-hide-sold-out') === 'true';

    var inputs = Array.prototype.slice.call(root.querySelectorAll('.bl-variant-input'));
    var optionCount = root.querySelectorAll('.bl-variant-row').length;

    /* Current selection, one value per option position */
    function selection() {
      var sel = [];
      for (var pos = 1; pos <= optionCount; pos++) {
        var checked = root.querySelector(
          '.bl-variant-input[data-option-position="' + pos + '"]:checked'
        );
        sel.push(checked ? checked.value : null);
      }
      return sel;
    }

    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && v.options[j] !== sel[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    /* Mark option values that cannot be combined with the rest of the
       current selection. Only the OTHER positions are held fixed, which
       is how Shopify's own picker behaves. */
    function refreshAvailability() {
      var sel = selection();

      for (var pos = 1; pos <= optionCount; pos++) {
        var opts = root.querySelectorAll(
          '.bl-variant-input[data-option-position="' + pos + '"]'
        );

        Array.prototype.forEach.call(opts, function (input) {
          var test = sel.slice();
          test[pos - 1] = input.value;

          var exists = false, available = false;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i], ok = true;
            for (var j = 0; j < test.length; j++) {
              if (test[j] !== null && v.options[j] !== test[j]) { ok = false; break; }
            }
            if (ok) {
              exists = true;
              if (v.available) { available = true; break; }
            }
          }

          var label = root.querySelector('label[for="' + input.id + '"]');
          if (!label) return;

          label.classList.toggle('is-unavailable', !available);
          label.classList.toggle('is-nonexistent', !exists);

          if (hideSold && !available) {
            label.style.display = 'none';
            input.disabled = true;
          } else {
            label.style.display = '';
            input.disabled = false;
          }
        });
      }
    }

    /* Point the gallery at the media bound to this variant.

       Only runs when the variant actually carries its own image. A
       variant with no assigned image leaves the gallery alone rather
       than snapping back to slide one, which would otherwise undo the
       shopper's browsing on every option change. */
    function syncGallery(variant) {
      if (!variant || !variant.featured_media_id) return;

      var gallery = document.querySelector('[data-bl-gallery]');
      if (!gallery) return;

      /* Preferred path: the gallery's own API */
      if (gallery.blGallery && gallery.blGallery.showByMediaId) {
        gallery.blGallery.showByMediaId(variant.featured_media_id, {
          respectPlayback: true
        });
        return;
      }

      /* Fallback for a gallery that has not upgraded, or the stock one.
         Sets the slide directly rather than relying on a thumbnail
         existing, since thumbnails only render when media.size > 1. */
      var slides = gallery.querySelectorAll('[data-bl-slide]');
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) ===
            String(variant.featured_media_id)) {
          for (var j = 0; j < slides.length; j++) {
            slides[j].classList.toggle('is-active', j === i);
            var v = slides[j].querySelector('video');
            if (v && j !== i && !v.paused) { try { v.pause(); } catch (e) {} }
          }
          gallery.querySelectorAll('[data-bl-thumb]').forEach(function (t) {
            t.classList.toggle('is-active',
              t.getAttribute('data-media-id') === String(variant.featured_media_id));
          });
          var counter = gallery.querySelector('[data-bl-current]');
          if (counter) counter.textContent = String(i + 1);
          break;
        }
      }
    }

    function update() {
      refreshAvailability();

      var sel = selection();
      var variant = findVariant(sel);

      /* Reflect the chosen value next to each option label */
      for (var pos = 1; pos <= optionCount; pos++) {
        var out = root.querySelector('[data-bl-selected-for="' + pos + '"]');
        if (out && sel[pos - 1]) out.textContent = sel[pos - 1];
      }

      if (!variant) {
        /* Combination does not exist. Disable buying, say so plainly. */
        document.querySelectorAll('.bp-atc, #bp-sticky-btn, .bl-sticky-atc')
          .forEach(function (b) { b.disabled = true; b.textContent = 'UNAVAILABLE'; });
        return;
      }

      /* Hidden id input, this is what actually gets purchased */
      if (form) {
        var idInput = form.querySelector('[name="id"]');
        if (idInput) idInput.value = variant.id;
      }

      /* Price displays */
      var priceEl = document.getElementById('bp-price-display');
      if (priceEl) priceEl.textContent = money(variant.price);

      var stickyPrice = document.getElementById('bp-sticky-price');
      if (stickyPrice) stickyPrice.textContent = money(variant.price);

      document.querySelectorAll('.bl-sticky-price').forEach(function (el) {
        el.textContent = money(variant.price);
      });

      /* Compare-at */
      var cmp = document.querySelector('#bp-price-display')
        ? document.querySelector('#bp-price-display').previousElementSibling
        : null;
      if (cmp && cmp.tagName === 'S') {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          cmp.textContent = money(variant.compare_at_price);
          cmp.style.display = '';
        } else {
          cmp.style.display = 'none';
        }
      }

      syncGallery(variant);

      /* Address bar, so the variant is shareable and back-button works */
      if (updateUrl && variant.url && window.history && window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) { /* non-fatal */ }
      }

      /* ── Emit BOTH event names ──
         The stock theme fires 'variant:change'. The existing Brutech
         listener in main-product.liquid listens for 'variant:changed'.
         Firing both means neither has to be edited. */
      var detail = {
        variant: variant,
        formId: formId,
        previousVariant: null
      };

      ['variant:change', 'variant:changed'].forEach(function (name) {
        var ev = new CustomEvent(name, { bubbles: true, detail: detail });
        if (form) form.dispatchEvent(ev);
        document.dispatchEvent(ev);
      });
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', update);
    });

    /* Keyboard: arrow keys move within a radiogroup */
    root.querySelectorAll('.bl-variant-opts').forEach(function (group) {
      group.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var labels = Array.prototype.slice.call(
          group.querySelectorAll('.bl-variant-opt:not([style*="display: none"])')
        );
        var active = document.activeElement;
        var idx = labels.indexOf(active.closest ? active.closest('.bl-variant-opt') : null);
        if (idx === -1) return;
        e.preventDefault();
        var nextIdx = e.key === 'ArrowRight' ? idx + 1 : idx - 1;
        if (nextIdx < 0) nextIdx = labels.length - 1;
        if (nextIdx >= labels.length) nextIdx = 0;
        var target = labels[nextIdx];
        var inp = document.getElementById(target.getAttribute('for'));
        if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        target.focus();
      });
    });

    /* Initial pass, sets availability without firing analytics events */
    refreshAvailability();
  }

  function boot() {
    try {
      document.querySelectorAll('[data-bl-variants]').forEach(init);
    } catch (e) {
      console.warn('[Brutech] Variant picker:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', boot);
})();
